<template>
  <v-container v-if="relatorioCarregado" fluid>
    <validation-observer ref="observer" v-slot="{ invalid }">
      <v-row>
        <v-col>
          <basic-info-modelo ref="basicInfo" :nomeRelatorioModelo="relatorio.nome" :descricao="relatorio.descricao" />
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <modelo-parametros ref="parametros" :relatorio="relatorio" />
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-btn
            color="success"
            style="float: right"
            min-width="100"
            class="ml-3"
            :disabled="invalid"
            :loading="loading"
            @click="salvar()"
          >
            Salvar
          </v-btn>
        </v-col>
      </v-row>
    </validation-observer>
  </v-container>
</template>

<script>
  import RelatoriosModelosService from '@/services/RelatoriosModelosService';
  import RelatoriosService from '@/services/RelatoriosService';

  export default {
    components: {
      BasicInfoModelo: () => import('@/components/relatorios/BasicInfoModelo'),
      ModeloParametros: () => import('@/components/relatorios/ModeloParametros')
    },

    data: () => ({
      relatorio: {},
      loading: false,
      nome: ''
    }),

    computed: {
      relatorioCarregado() {
        return JSON.stringify(this.relatorio) !== '{}';
      }
    },

    created() {
      this.getRelatorioModelo();
    },

    methods: {
      getRelatorioModelo() {
        RelatoriosModelosService.getRelatorio(this.$route.params.id)
          .then((response) => {
            this.relatorio = response.data.consultaModelo;
          })
          .catch(() => this.$toast.error('Erro ao recuperar relatório modelo.', '', { position: 'topRight' }));
      },

      salvar() {
        let data = {
          modelo_id: this.$route.params.id,
          nome: this.$refs.basicInfo.exportCampos(),
          parametros: this.$refs.parametros.exportCampos()
        };

        this.loading = true;

        RelatoriosService.postRelatorioModelo(data)
          .then(() => {
            this.$toast.success('Relatório salvo com sucesso.', '', { position: 'topRight' });
            this.$router.push({ name: 'Relatórios Histórico' });
          })
          .catch((error) => {
            console.error(error);
            this.$toast.error('Erro ao salvar relatório modelo.', '', { position: 'topRight' });
          })
          .finally(() => (this.loading = false));
      }
    }
  };
</script>